import React, {Component} from 'react';
import {Alert} from "reactstrap";


export default class MyAlert extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
      message: props.message,
      icon: props.icon,
      color: props.color,
      hide: props.hide
    };

    this.onDismiss = this.onDismiss.bind(this);

  }

  componentDidMount() {
    this._isMounted = true;
  }

  shouldComponentUpdate(prevProps, prevState, snapshot) {
    if (this.props.alertId !== prevProps.alertId) {
      this.setState({
        show: prevProps.show,
        message: prevProps.message,
        icon: prevProps.icon,
        color: prevProps.color,
        hide: prevProps.hide
      });

      if (prevProps.show === true) {
        setTimeout(() => {
          this.setState({
            show: false

          });
        }, this.state.hide ? this.props.hide : 3000)
      }
    }
    return true;

  }

  componentWillUnmount() {
    this._isMounted = false;
  }


  onDismiss() {
    this.setState({show: false});
  }

  render() {

    return (

      <div className="alert-position">
        {this._isMounted &&
        <Alert color={this.state.color} isOpen={this.state.show} toggle={this.onDismiss}
               className="animated fadeIn ">
          {this.state.message}
        </Alert>
        }
      </div>

    )

  }
}
